import { SingleColumnCarouselItem } from '../CarouselItems'
import { IMAGE_RESOLUTIONS } from './constants'
import { SingleColumnCarouselProps } from './types'

export const SingleColumnCarousel = ({
  size,
  images,
}: SingleColumnCarouselProps) =>
  images.map((item, index) => (
    <SingleColumnCarouselItem
      imageWidth={IMAGE_RESOLUTIONS[size].width * 2}
      imageHeight={IMAGE_RESOLUTIONS[size].height * 2}
      key={item + index}
      item={item}
    />
  ))
